import React from 'react';
import '../style/DateTimeRange.scss';
import PropTypes from 'prop-types';
import { addFocusStyle, darkTheme, lightTheme } from '../utils/StyleUtils';
import Icons from '../../../../icons';

class MonthYearSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      monthFocus: false,
      yearFocus: false,
      showMonthDropdown: false,
      showYearDropdown: false,
    };

    this.monthFocus = this.monthFocus.bind(this);
    this.yearFocus = this.yearFocus.bind(this);
    this.monthBlur = this.monthBlur.bind(this);
    this.yearBlur = this.yearBlur.bind(this);
    this.toggleMonthDropdown = this.toggleMonthDropdown.bind(this);
    this.toggleYearDropdown = this.toggleYearDropdown.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.dropdownRef = React.createRef();
    this.monthRefs = [];
    this.yearRefs = [];
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.dropdownRef && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ showMonthDropdown: false, showYearDropdown: false });
    }
  }

  monthFocus() {
    this.setState({ monthFocus: true });
  }

  monthBlur() {
    this.setState({ monthFocus: false });
  }

  yearFocus() {
    this.setState({ yearFocus: true });
  }

  yearBlur() {
    this.setState({ yearFocus: false });
  }

  toggleMonthDropdown() {
    this.setState(prevState => ({
      showMonthDropdown: !prevState.showMonthDropdown,
      showYearDropdown: false,
    }), () => {
      if (this.state.showMonthDropdown) {
        this.scrollToSelected('month');
      }
    });
  }

  toggleYearDropdown() {
    this.setState(prevState => ({
      showYearDropdown: !prevState.showYearDropdown,
      showMonthDropdown: false,
    }), () => {
      if (this.state.showYearDropdown) {
        this.scrollToSelected('year');
      }
    });
  }

  scrollToSelected(type) {
    if (type === 'month' && this.monthRefs[this.props.month]) {
      this.monthRefs[this.props.month].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } else if (type === 'year' && this.yearRefs[this.props.year]) {
      this.yearRefs[this.props.year].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  createCalendarMonths(months) {
    return this.mapToButtons(months, 'month');
  }

  createYears(years) {
    return this.mapToButtons(years, 'year');
  }

  mapToButtons(variableArray, type) {
    return variableArray.map((varInstance, i) => (
      <button
        key={i}
        onClick={() => this.handleButtonClick(type, varInstance)}
        ref={el => {
          if (type === 'month') {
            this.monthRefs[i] = el;
          } else if (type === 'year') {
            this.yearRefs[varInstance] = el;
          }
        }}
        className={
          (type === 'month' && i === this.props.month) ||
          (type === 'year' && varInstance === this.props.year)
            ? 'selected'
            : ''
        }
        style={{
          marginTop: '2px',
          marginBottom: '2px',
          backgroundColor: this.props.darkMode ? '#333' : '#fff',
          color: this.props.darkMode ? '#fff' : '#000',
          width: "100%"
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = "#7159A6"
          e.target.style.color = "#fff"
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = this.props.darkMode
            ? "#333"
            : "#fff";
          e.target.style.color = "#000"
        }}
      >
        {varInstance}
      </button>
    ));
  }

  handleButtonClick(type, value) {
    if (type === 'month') {
      const selectedMonthIndex = this.props.months.indexOf(value);
      this.props.changeMonthCallback({ target: { value: selectedMonthIndex } });
      this.setState({ showMonthDropdown: false });
    } else if (type === 'year') {
      this.props.changeYearCallback({ target: { value: value } });
      this.setState({ showYearDropdown: false });
    }
  }

  createGlyph(icon, onClickHandler, previous, next) {
    return (
      <div onClick={() => onClickHandler(previous, next)}>
        {Icons.chevronIconRightPurple}
      </div>
    );
  }

  createGlyphLeftArrow(icon, onClickHandler, previous, next) {
    return (
      <div onClick={() => onClickHandler(previous, next)}>
        {Icons.chevronIconLeftPurple}
      </div>
    );
  }

  render() {
    let months = this.createCalendarMonths(this.props.months);
    let years = this.createYears(this.props.years);
    let theme = this.props.darkMode ? darkTheme : lightTheme;
    let leftArrow = this.createGlyphLeftArrow(
      'chevron-left',
      this.props.changeMonthArrowsCallback,
      true,
      false
    );
    let rightArrow = this.createGlyph(
      'chevron-right',
      this.props.changeMonthArrowsCallback,
      false,
      true
    );
    let monthFocusStyle = {};
    monthFocusStyle = addFocusStyle(this.state.monthFocus, monthFocusStyle);
    let yearFocusStyle = {};
    yearFocusStyle = addFocusStyle(this.state.yearFocus, yearFocusStyle);

    return (
      <div className="monthYearContainer" ref={this.dropdownRef}>
        <div className="leftChevron">{leftArrow}</div>
        <div
          className={this.state.showMonthDropdown ? "multipleContentOnLine custom opened month" : "multipleContentOnLine custom month"}
          onBlur={this.monthBlur}
          style={monthFocusStyle}
        >
          <div onClick={this.toggleMonthDropdown} style={{ cursor: 'pointer', background: '#eeeeee !important', ...theme }}>
              <span className="valueSelected month">{this.props.months[this.props.month]}</span>

              <span className="downArrowIcon">{Icons.chevronDownArrowIcon}</span>

          </div>
          {this.state.showMonthDropdown && (
            <div className="selectedDropdown">
              {months}
            </div>
          )}
        </div>
        <div
          className={this.state.showYearDropdown ? "multipleContentOnLine custom opened year" : "multipleContentOnLine custom year"}
          onFocus={this.yearFocus}
          onBlur={this.yearBlur}
          style={yearFocusStyle}
        >
          <div onClick={this.toggleYearDropdown} style={{ cursor: 'pointer', background: '#eeeeee', ...theme }}>
            <><span className="valueSelected">{this.props.year}</span>
             <span className="downArrowIcon">{Icons.chevronDownArrowIcon}</span>
            </>
          </div>
          {this.state.showYearDropdown && (
            <div className="selectedDropdown">
              {years}
            </div>
          )}
        </div>
        <div className="rightChevron">{rightArrow}</div>
      </div>
    );
  }
}

MonthYearSelector.propTypes = {
  months: PropTypes.array.isRequired,
  years: PropTypes.array.isRequired,
  month: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired,
  changeMonthCallback: PropTypes.func.isRequired,
  changeYearCallback: PropTypes.func.isRequired,
  changeMonthArrowsCallback: PropTypes.func.isRequired,
  darkMode: PropTypes.bool,
};

export default MonthYearSelector;
